module.exports = __webpack_public_path__ + "media/KZ-YUZ.a7db77c5.ogg";